import { faChevronRight } from '~/assets';
import { SceneWrapper, SectionTitle } from '~/components';
import { IconProp } from '~/modules';
import {
  ChevronRightIcon,
  PaymentOption,
  PaymentOptionIcon,
  PaymentOptionTitle,
  PaymentOptionWrapper,
  SectionWrapper,
} from './styles';

interface CreditSimulationMethodProps {
  paymentOptions: {
    title: string;
    icon: IconProp;
    onPress: () => void;
  }[];
}

const CreditSimulationMethod = ({
  paymentOptions,
}: CreditSimulationMethodProps) => {
  return (
    <SceneWrapper>
      <SectionTitle>Escolha a forma de receber o dinheiro</SectionTitle>
      <SectionWrapper>
        {paymentOptions.map((option, index) => (
          <PaymentOptionWrapper key={index}>
            <PaymentOption onPress={option.onPress} id={index.toString()}>
              <PaymentOptionIcon icon={option.icon} />
              <PaymentOptionTitle>{option.title}</PaymentOptionTitle>
            </PaymentOption>
            <ChevronRightIcon icon={faChevronRight} />
          </PaymentOptionWrapper>
        ))}
      </SectionWrapper>
    </SceneWrapper>
  );
};

export default CreditSimulationMethod;
